// utils/localStorage.ts
export const getStoredCraneId = (): number | null => {
  const storedCraneId = localStorage.getItem("selectedCraneId");
  if (storedCraneId) {
    const parsedCraneId = parseInt(storedCraneId);
    if (!isNaN(parsedCraneId)) {
      return parsedCraneId;
    }
  }
  return null;
};

export const getStoredOperatorId = (): number | null => {
  const storedOperatorId = localStorage.getItem("selectedOperatorId");
  if (storedOperatorId) {
    const parsedOperatorId = parseInt(storedOperatorId);
    if (!isNaN(parsedOperatorId)) {
      return parsedOperatorId;
    }
  }
  return null;
};

export const setStoredIds = (craneId: number, operatorId: number) => {
  localStorage.setItem("selectedCraneId", craneId.toString());
  localStorage.setItem("selectedOperatorId", operatorId.toString());
};

export const clearStoredIds = () => {
  localStorage.removeItem("selectedCraneId");
  localStorage.removeItem("selectedOperatorId");
};

// Check if we have valid IDs in localStorage on initial load
export const hasValidStoredIds = (shouldBypassCraneSelection: boolean) => {
  const storedCraneId = getStoredCraneId();
  const storedOperatorId = getStoredOperatorId();

  // Check if we have valid IDs (not null, not 0, not -1 for regular users)
  if (shouldBypassCraneSelection) {
    // For bypass users, -1 is valid
    return storedCraneId !== null && storedOperatorId !== null;
  } else {
    // For regular users, need valid IDs (not 0, not -1)
    return (
      storedCraneId !== null &&
      storedCraneId !== 0 &&
      storedCraneId !== -1 &&
      storedOperatorId !== null &&
      storedOperatorId !== -1
    );
  }
};
